import React, { useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AOS from 'aos';
import 'aos/dist/aos.css';
import GroupsIcon from '@mui/icons-material/Groups';
import PublicIcon from '@mui/icons-material/Public';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  background: 'rgba(255, 255, 255, 0.95)',
  borderRadius: theme.spacing(2),
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-10px)',
    boxShadow: theme.shadows[10],
  },
}));

const CoordinationAndGlobalNetworking = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <Box sx={{ mt: 10, pb: 10 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            textAlign: 'center',
            mb: 6,
            color: '#1E88E5',
          }}
        >
          Coordination and Support & Global Networking
        </Typography>

        <Grid container spacing={6}>
          {/* Coordination and Support */}
          <Grid item xs={12} md={6}>
            <div data-aos="fade-up">
              <StyledCard>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <GroupsIcon
                      color="primary"
                      sx={{ fontSize: 40, mr: 1 }}
                    />
                    <Typography variant="h5" fontWeight={600}>
                      Coordination and Support
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    Coordinating and supporting members’ engagement in humanitarian, development, and advocacy efforts by:
                    <ul>
                      <li>Establishing issue-based thematic forums for advocacy and networking</li>
                      <li>Building member organizations' capacity</li>
                      <li>Facilitating information and experience sharing</li>
                      <li>Providing project funds and enabling implementation through members</li>
                    </ul>
                  </Typography>
                </CardContent>
              </StyledCard>
            </div>
          </Grid>

          {/* Global Networking */}
          <Grid item xs={12} md={6}>
            <div data-aos="fade-up" data-aos-delay="200">
              <StyledCard>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <PublicIcon
                      color="primary"
                      sx={{ fontSize: 40, mr: 1 }}
                    />
                    <Typography variant="h5" fontWeight={600}>
                      Global Networking
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    Building partnerships with regional, national, and global CSO/NGO networks to advocate and influence policy on issues like:
                    <ul>
                      <li>CSO/NGO operating spaces</li>
                      <li>Climate change and its consequences</li>
                      <li>Human trafficking</li>
                      <li>IDPs and refugee issues</li>
                      <li>Gender inequalities</li>
                      <li>Global development inequalities and poverty</li>
                      <li>Ethnic-minority rights</li>
                      <li>Globalization and cultural rights</li>
                    </ul>
                  </Typography>
                </CardContent>
              </StyledCard>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CoordinationAndGlobalNetworking;
